export enum LocalesCodeEnum {
    ES = 'es_AR.UTF-8',
    EN = 'en_US.UTF-8',
}
